import api from "./api";

class ChannelService {
  // Get all channels
  async getChannels() {
    try {
      const response = await api.get("/channels/");
      return {
        success: true,
        data: response.data.channels || [],
        total: response.data.total || 0,
      };
    } catch (error) {
      console.error("Get channels error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to fetch channels"
      );
    }
  }

  // Get channel by ID
  async getChannelById(id) {
    try {
      const response = await api.get(`/channels/${id}`);
      return {
        success: true,
        data: {
          channel: response.data,
          connection: {
            type: response.data.type,
            status:
              response.data.status === "active" ? "connected" : "disconnected",
            isConnected: response.data.status === "active",
            phoneNumber: response.data.config?.phone_number || null,
          },
          lastChecked: new Date().toISOString(),
        },
      };
    } catch (error) {
      console.error("Get channel by ID error:", error);
      throw new Error(error.response?.data?.error || "Channel not found");
    }
  }

  // Create new channel
  async createChannel(channelData) {
    try {
      const response = await api.post("/channels/", channelData);
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      console.error("Create channel error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to create channel"
      );
    }
  }

  // Get QR code for channel
  async getChannelQR(channelId, refresh = false) {
    try {
      const params = refresh ? { refresh: "true" } : {};
      const response = await api.get(`/whatsapp/${channelId}/qr`, {
        params,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Get QR code error:", error);
      throw new Error(error.response?.data?.error || "Failed to get QR code");
    }
  }

  // Get WhatsApp status for channel
  async getWhatsAppStatus(channelId) {
    try {
      const response = await api.get(`/whatsapp/${channelId}/status`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Get WhatsApp status error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to get WhatsApp status"
      );
    }
  }

  // Update channel status
  async updateChannelStatus(channelId, status) {
    try {
      const response = await api.put(`/channels/${channelId}`, { status });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Update channel status error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to update channel status"
      );
    }
  }

  // Get channel statistics
  async getChannelStats(channelId) {
    try {
      const response = await api.get(`/channels/${channelId}/status`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Get channel stats error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to get channel stats"
      );
    }
  }

  // Retry WhatsApp setup
  async retryWhatsAppSetup(channelId) {
    try {
      const response = await api.post(`/channels/${channelId}/retry-whatsapp`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Retry WhatsApp setup error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to retry WhatsApp setup"
      );
    }
  }

  // Delete channel
  async deleteChannel(channelId) {
    try {
      const response = await api.delete(`/channels/${channelId}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Delete channel error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to delete channel"
      );
    }
  }

  // Update channel configuration
  async updateChannelConfig(channelId, configData) {
    try {
      const response = await api.put(`/channels/${channelId}`, configData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Update channel config error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to update channel configuration"
      );
    }
  }

  // Update channel agent assignment
  async updateChannelAgent(channelId, agentId) {
    try {
      const response = await api.put(`/channels/${channelId}`, {
        agent_id: agentId,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Update channel agent error:", error);
      throw new Error(
        error.response?.data?.error || "Failed to update channel agent"
      );
    }
  }
}

export default new ChannelService();
